import dayjs from 'dayjs'

const state = {
  lands: ['澎湖', '金門', '馬祖', '綠島', '連江', '琉球'],
  tagOptions: ['本人', '家人', '親屬', '同事', '朋友', '客戶'],
  pnList: `ㄅㄆㄇㄈ
           ㄉㄊㄋㄌ
           ㄍㄎㄏ
           ㄐㄑㄒ
           ㄓㄔㄕㄖ
           ㄗㄘㄙ
           ㄧㄨㄩ
           ㄚㄛㄜㄝ
           ㄞㄟㄠㄡ
           ㄢㄣㄤㄥ
           ㄦ`.split('\n').map(item => item.trim().split('')),
  editModel: null,
}

const getters = {
  // 倉庫收件人
  renderWhsConsignee: (state, getters, rootState) => (addr) => {
    if (!addr) return ''
    let addrName = ''
    let mchUid = ''
    for (const x in rootState.userAddrs) {
      if (parseInt(rootState.userAddrs[x].isPrimary) === 1) {
        addrName = rootState.userAddrs[x].consignee
        mchUid = rootState.userAddrs[x].mchUid
        break
      }
    }
    return addr.consignee
      .replace(/\[name\]/, addrName)
      .replace(/\[mchUid\]/, mchUid)
  },
  // 標籤
  renderLabel: (state, getters) => (addr) => {
    const label = addr && addr.label ? addr.label : addr
    return label
      ? `<span class="px-1 purple lighten-5 deep-purple--text text--darken-4">${label}</span>`
      : ''
  },
  // 完整地址
  fullAddress: (state, getters) => (addr) => {
    return !addr
      ? ''
      : `${addr.province}${addr.city}${addr.district}
         ${addr.street}${addr.desc}${addr.desc2}`
  },
  homeAddrs (state, getters, rootState) {
    return rootState.userAddrs.filter(item => !item.chaoshang.stoCode)
  },
  chaoshangAddrs (state, getters, rootState) {
    return rootState.userAddrs.filter(item => item.chaoshang.stoCode)
  }
}

const mutations = {
  setEditModel (state, editModel) {
    state.editModel = editModel
  },
}

const actions = {
  index ({ state, dispatch, rootState }, params) {
    return rootState.axios.get('/address/v1frontend/address/index', { params })
      .then(async (res) => {
        res.data.list = await dispatch('formatAddr', res.data.list)
        // commit('setUserAddrs', res.data.list || [], {root: true})
        return res
      })
  },
  userAddrs ({ state, dispatch, commit, rootState }, params) {
    return rootState.axios.get('/address/v1frontend/address/index', { params })
      .then(async (res) => {
        res.data.list = await dispatch('formatAddr', res.data.list)
        commit('setUserAddrs', res.data.list || [], { root: true })
        return res
      })
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/address/v1frontend/address/create', params)
  },
  view ({ state, dispatch, rootState }, params) {
    return rootState.axios.get('/address/v1frontend/address/view', { params }).then(async (res) => {
      res.data.model = (await dispatch('formatAddr', [res.data.model]))[0]
      return res
    })
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/address/v1frontend/address/update', params)
  },
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/address/v1frontend/address/delete', params)
  },
  twCities ({ state, commit, rootState }, params) {
    return rootState.axios.get('/address/v1frontend/address/tw-cities', { params })
  },
  chaoshangStores ({ state, commit, rootState }, params) {
    return rootState.axios.get('/address/v1frontend/address/chaoshang-stores', { params })
  },
  checkLock ({ state, commit, rootState }, params) {
    return rootState.axios.post('/address/v1frontend/address/check-lock', params)
  },
  updateRnaPhotos ({ state, commit, rootState }, params) {
    return rootState.axios.post('/address/v1frontend/address/update-rna-photos', params)
  },
  updateSender ({ state, commit, rootState }, params) {
    return rootState.axios.post('/address/v1frontend/address/update-sender', params)
  },
  sendRnaTel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/address/v1frontend/address/send-rna-tel', params)
  },
  rnaTel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/address/v1frontend/address/rna-tel', params)
  },
  natGcisCmpyDetail ({ state, commit, rootState }, params) {
    return rootState.axios.get('/address/v1frontend/address/nat-gcis-cmpy-detail', {
      params,
      noShowError: true
    })
  },
  formatAddr ({ state }, addrs) {
    return (addrs || []).map(addr => {
      let tradevanAddr = { ...addr }
      if (addr.extraInfo && addr.extraInfo.tradevanAddr && addr.extraInfo.tradevanAddr.addrid) {
        tradevanAddr = addr.extraInfo.tradevanAddr
      }

      const canEdit = !(addr.isLocked & 8)
      // if (!canEdit) {
      //   if (dayjs().diff(addr.updatedAt, 'day') > 14) {
      //     canEdit = true
      //   }
      // }
      const isLandAddr = !!state.lands.find(land => addr.city.indexOf(land) > -1 || addr.district.indexOf(land) > -1)
      tradevanAddr.blocks = tradevanAddr.blocks || []
      tradevanAddr.blocks = tradevanAddr.blocks
        .filter(item => {
          if (String(item.abDuration) === '-1') return true
          if (String(item.abDuration) === '0') return false
          return !item.abDuration || item.abDuration > new Date() / 1000
        })
        .map(item => {
          let abStartAt
          if (item.abType === 'bn') {
            abStartAt = dayjs(item.abDuration * 1000).subtract(180, 'day').format('YYYY-MM-DD')
          }
          return {
            ...item,
            abStartAt,
          }
        })
      const blocks = []
      tradevanAddr.blocks.filter(item => {
        if (String(item.abDuration) === '-1') return true
        if (String(item.abDuration) === '0') return false
        return !item.abDuration || item.abDuration > new Date() / 1000
      }).forEach(item => {
        let abStartAt
        if (item.abType === 'bn') {
          abStartAt = dayjs(item.abDuration * 1000).subtract(180, 'day').format('YYYY-MM-DD')
        }
        if (blocks.find(block => block.abBrief === item.abBrief)) {
          return
        }
        blocks.push({
          ...item,
          abStartAt,
        })
      })

      return {
        ...addr,
        blocks,
        tradevanAddr: {
          ...tradevanAddr,
          realName: 1 & tradevanAddr.isLocked
        },
        canEdit,
        isLandAddr,
        isSameTradevan: addr.isCompany === 1 || (tradevanAddr.consignee === addr.consignee && tradevanAddr.mobile === addr.mobile)
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
